<template>
  <div>
    <AdButton v-if="$feature('showDesignMenuItems')" type="compare" text="compare TEST" darker medium @click="open" />

    <v-dialog v-model="dialog" width="1200" persistent>
      <v-card>
        <AdCardTitle dialog>
          {{ $t("compare-scenarios") }}
          <v-spacer></v-spacer>
          <AdButton type="cancel" color="grey" @click="close" />
        </AdCardTitle>

        <v-card-text class="pt-3">

          <TreeDataTable
            :items="scenario1"
            :headers="headersRepresentingTemplate"
            :loading="panelLoading || scenario1 === null"
          >

            <!--
              name + of common dataset
            -->
            <template v-slot:[`item.name`]="{ name, absent, type, statusCode, __meta }">
              <v-icon class="pr-2" :color="$filters.getStatusColor(statusCode)">
                {{ type === "group" ? "mdi-folder" : "mdi-cube" }}
              </v-icon>
              <span :class="(absent && scenario2[__meta.pointer].absent) ? 'absent' : 'present'">{{
                $filters.getMatchingTranslation({
                  value: name,
                })
              }}</span>
            </template>

            <!--
              card / conf of scenario 1
            -->
            <template
              v-slot:[`item.card`]="{ absent, minimumMultiplicity, maximumMultiplicity, conformance, __meta }"
            >
              <span v-if="!absent" class="present">
                <span
                  class="pa-1"
                  :class="
                    minimumMultiplicity !== scenario2[__meta.pointer].minimumMultiplicity
                      ? 'green lighten-4'
                      : ''
                  "
                  >{{ minimumMultiplicity }}</span
                >
                <span>..</span>
                <span
                  class="pa-1"
                  :class="
                    maximumMultiplicity !== scenario2[__meta.pointer].maximumMultiplicity
                      ? 'green lighten-4'
                      : ''
                  "
                  >{{ maximumMultiplicity }}</span
                >
                <span> </span>
                <span
                  class="pa-1"
                  :class="
                    conformance !== scenario2[__meta.pointer].conformance
                      ? 'green lighten-4'
                      : ''
                  "
                  >{{ conformance }}</span
                >
              </span>
              <span
                v-else class="pa-1 green lighten-4">
                NP
              </span>
            </template>

            <!--
              card / conf of scenario 2
            -->
            <template
              v-slot:[`item.card2`]="{ minimumMultiplicity, maximumMultiplicity, conformance, __meta }"
            >
              <span v-if="!scenario2[__meta.pointer].absent" class="present">
                <span
                    class="pa-1"
                    :class="
                      minimumMultiplicity !== scenario2[__meta.pointer].minimumMultiplicity
                        ? 'red lighten-4'
                        : ''
                    "
                    >{{ scenario2[__meta.pointer].minimumMultiplicity }}</span
                  >
                  <span>..</span>
                  <span
                    class="pa-1"
                    :class="
                      maximumMultiplicity !== scenario2[__meta.pointer].maximumMultiplicity
                        ? 'red lighten-4'
                        : ''
                    "
                    >{{ scenario2[__meta.pointer].maximumMultiplicity }}</span
                  >
                  <span> </span>
                  <span
                    class="pa-1"
                    :class="
                      conformance !== scenario2[__meta.pointer].conformance
                        ? 'red lighten-4'
                        : ''
                    "
                    >{{ scenario2[__meta.pointer].conformance }}</span
                  >
              </span>
              <span
                v-else class="pa-1 red lighten-4">
                NP
              </span>
            </template>

          </TreeDataTable>

        </v-card-text>

        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TreeDataTable from '@/components/Utilities/TreeDataTable'

export default {
  name: 'ScenarioCompareDialog',
  components: {
    TreeDataTable
  },
  props: {
    scenario1: {
      type: [Array, Object],
      required: true
    },
    scenario2: {
      type: [Array, Object],
      required: false
    }
  },
  data () {
    return {
      dialog: false,
      panelLoading: false,
      headersRepresentingTemplate: [
        { text: 'Name', value: 'name', width: '50%' },
        { text: 'Card/Conf', value: 'card', width: '25%' },
        { text: 'Card/Conf 2', value: 'card2', width: '25%' }
      ]
    }
  },
  computed: {
    ...mapState({
      projectPrefix: (state) => state.project.projectSelected?.prefix
    }),

    /**
     * Get table header structure.
     *
     * The table structure defines which field should shown
     * and in base of which key they are sortable. The fix width
     * for the columns can also defined here.
     *
     * @returns {[*]}
     */
    headers () {
      return [
        { text: this.$t('type'), value: 'type', sortable: true, width: '5%' },
        { text: this.$t('name'), value: 'name', sortable: true, width: '25%' },
        {
          text: this.$t('description'),
          value: 'desc',
          sortable: false,
          width: '65%'
        },
        {
          text: this.isUserLoggedIn ? this.$t('actions') : '',
          value: 'data-actions',
          width: '100px',
          hidden: false
        }
      ]
    }
  },
  created () {
    this.calculateDiff()
  },
  methods: {
    /**
     * Open Compare Scenario dialog.
     *
     * @param item
     * @return {Promise<void>}
     */
    async open () {
      // this.$refs.scenarioCompareDialog.open(item)
      this.dialog = true
    },

    /**
     * Close the dialog.
     */
    close () {
      // Close dialog.
      this.dialog = false
    },

    /**
     * Calculate the diff of the two equal length arrays scenario and scenario 2
     */
    calculateDiff () {
      // for (let i = 0; i < this.scenario1.length; i++) {
      //   this.scenario1[i].card2 = this.scenario2[i].card
      // }
    }
  }
}
</script>

<style lang="scss" scoped>

.absent {
  color: #888;
}
.present {
  font-weight: bold;
}

</style>
